import { render, staticRenderFns } from "./MonthlyEPF.vue?vue&type=template&id=30e50dc3"
import script from "./MonthlyEPF.vue?vue&type=script&lang=js"
export * from "./MonthlyEPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports